//Lib

//Constant
import languageKey from '../../../../i18n/languageKey'

//Store & Action

//External Type
import { LanguageType } from './language'

//External Hook
import useTranslate from '../../../../i18n/useTranslate'

const useLanguage = (props: LanguageType) => {
    //Store & Action

    //External Hook
    const translate = useTranslate()

    const handleClickEN = () => {
        if (translate.languageStore.currentLanguage !== languageKey.en) {
            translate.setChangeLanguage(languageKey.en)
        }
    }
    const handleClickTH = () => {
        if (translate.languageStore.currentLanguage !== languageKey.th) {
            translate.setChangeLanguage(languageKey.th)
        }
    }
    return {
        lang: translate.languageStore.currentLanguage,
        onClickEN: handleClickEN,
        onClickTH: handleClickTH,
    }
}

export default useLanguage
